var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile-action',{class:{'grow-2': _vm.$vuetify.breakpoint.xsOnly}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-spacer'),_vm._v(" "),_c('v-layout',{staticClass:"mr-2",class:{
          'msr--text': _vm.highlighted,
          'grey--text text--darken-3': !_vm.highlighted,
        },style:({
          'font-size':
            _vm.$vuetify.breakpoint.xsOnly && _vm.coverSize === 'mini' ? '9px' : '13px',
        }),attrs:{"column":"","align-end":""}},[(_vm.showLabel)?_c('div',{class:{
            'grey--text text--darken-3': !_vm.highlightLabel,
            'msr--text': _vm.highlightLabel,
          }},[_vm._v("\n          "+_vm._s(_vm.$t(_vm.label))+":\n        ")]):_vm._e(),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.channel.name))])]),_vm._v(" "),(_vm.channel && _vm.channel.cover)?_c('img',{class:(_vm.coverSize + "-cover-image"),attrs:{"src":_vm.channel.cover,"width":_vm.coverSize === 'mini' ? '36px' : '48px',"height":_vm.coverSize === 'mini' ? '36px' : '48px'}}):_c('div',{class:(_vm.coverSize + "-cover-image")},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("\n          music_note\n        ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MiniRadioChannelTileAction.vue?vue&type=template&id=4ee372ef&scoped=true&
// module id = 1821
// module chunks = 5